import { render, staticRenderFns } from "./userPermissions.vue?vue&type=template&id=a603d7a2&scoped=true&"
import script from "./userPermissions.vue?vue&type=script&lang=js&"
export * from "./userPermissions.vue?vue&type=script&lang=js&"
import style0 from "./userPermissions.vue?vue&type=style&index=0&id=a603d7a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a603d7a2",
  null
  
)

export default component.exports